import { render } from "./ColumnsChart.vue?vue&type=template&id=36482e78&scoped=true"
import script from "./ColumnsChart.vue?vue&type=script&lang=js"
export * from "./ColumnsChart.vue?vue&type=script&lang=js"

import "./ColumnsChart.vue?vue&type=style&index=0&id=36482e78&lang=scss&scoped=true"

import exportComponent from "/Applications/dev/FLEXX_FREIGHT/flexx-freight-stats/website/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-36482e78"]])

export default __exports__